import React from 'react';
import { Stethoscope, FileText, Users, Factory, Plane, Gavel, ArrowRight } from 'lucide-react';
const services = [{
  title: 'Personal Injury',
  icon: Stethoscope,
  outcome: 'Precise injury grading and prognosis for accurate quantum in RTA, workplace, and public liability claims.',
  link: '/services/personal-injury'
}, {
  title: 'Clinical Negligence',
  icon: FileText,
  outcome: 'Robust breach-of-duty analysis with screening, causation, and condition & prognosis reports.',
  link: '/services/clinical-negligence'
}, {
  title: 'Family Court',
  icon: Users,
  outcome: 'Independent medical assessments for care proceedings, custody disputes, and child protection.',
  link: '/services/family-court'
}, {
  title: 'Criminal Cases',
  icon: Gavel,
  outcome: 'Psychiatric and medical expert evidence for fitness to plead, diminished responsibility, and mental state assessments.',
  link: '/services/criminal-cases'
}, {
  title: 'Immigration',
  icon: Plane,
  outcome: 'Medico-legal reports for asylum, human rights, and immigration tribunal proceedings.',
  link: '/services/immigration'
}, {
  title: 'Industrial Diseases',
  icon: Factory,
  outcome: 'Specialist NIHL, respiratory, and occupational disease reports with fast turnaround.',
  link: '/services/industrial-disease'
}];
export function ServicesGrid() {
  return <section id="services" className="py-10 bg-[#F8FAFC]" aria-label="Our specialist medico-legal services" data-id="element-419">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-420">
        <div className="text-center max-w-2xl mx-auto mb-8" data-id="element-421">
          <h2 className="text-3xl md:text-4xl font-bold text-ink-900 tracking-tight mb-4" data-id="element-422">
            Specialist Reports, Real Outcomes
          </h2>
          <p className="text-lg text-ink-500 leading-relaxed" data-id="element-423">
            Every report is built to move your case forward — clear, compliant,
            and ready for court.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-424">
          {services.map(service => <a key={service.title} href={service.link} className="group bg-white rounded-2xl border border-transparent hover:border-warm-300 p-7 transition-all duration-300 hover:shadow-md flex flex-col" data-id="element-425">
              <div className="w-10 h-10 bg-[#F8FAFC] rounded-lg flex items-center justify-center text-ink-500 mb-5 group-hover:text-teal-600 transition-colors duration-300" data-id="element-426">
                <service.icon className="h-5 w-5" strokeWidth={1.5} data-id="element-427" />
              </div>

              <h3 className="text-lg font-bold text-ink-900 mb-2" data-id="element-428">
                {service.title}
              </h3>

              <p className="text-ink-500 leading-relaxed text-[15px] mb-5 flex-1" data-id="element-429">
                {service.outcome}
              </p>

              <span className="inline-flex items-center text-sm font-semibold text-teal-600 group-hover:text-teal-700 transition-colors duration-300" data-id="element-430">
                Learn more
                <ArrowRight className="ml-1.5 h-4 w-4 group-hover:translate-x-1 transition-transform duration-200" data-id="element-431" />
              </span>
            </a>)}
        </div>
      </div>
    </section>;
}